// extracted by mini-css-extract-plugin
export default {"socialCard":"SocialMediaSettings_socialCard__2r21T"};